import { SUPPORTED_LOCALES, type Locale } from '../constants/locales';

/**
 * Custom hook to get available locales
 * @returns Object with locale data and loading state
 * @description Returns the static list of supported locales.
 * The data is immediately available (no async loading).
 */
export function useLocales() {
  return {
    data: SUPPORTED_LOCALES,
    isLoading: false,
    error: null,
  };
}

/**
 * Transform locale data to SelectOption format
 * @param locales Array of locale objects
 * @returns Array of select options
 */
export function localesToSelectOptions(locales: Locale[]): Array<{ value: string; label: string }> {
  return locales.map((locale) => ({
    value: locale.code,
    label: locale.language,
  }));
}
